<template>
  <div>
    <v-data-table
      mobile-breakpoint="0"
      item-key="id"
      :options.sync="tableOptions"
      :server-items-length="count"
      :items-per-page="5"
      :headers="headers"
      :items="items"
      :footer-props="footerTable"
      v-bind="this.$attrs"
      disable-sort
    >
      <template v-slot:[`item.student`]="{ item }">
        <CardStudentName :student="item.student" link />
      </template>

      <template v-for="qh in questionHeaders" v-slot:[`item.${qh.value}`]="{ item }">
        <div :key="qh.value" v-html="getAnswer(item, qh.value)" />
      </template>

      <template v-slot:[`item.createdAt`]="{ item }">
        {{ item.createdAt | ddmmyyyyhhmm }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn icon @click="() => onEdit(item)" color="primary">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <StudentAnswerEditPopup ref="edit-popup" />
  </div>
</template>
<script>
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import StudentAnswerEditPopup from './StudentAnswerEditPopup.vue'
import { mapActions, mapState } from 'vuex'
import { get } from 'lodash'

export default {
  components: { CardStudentName, StudentAnswerEditPopup },
  data: () => ({ tableOptions: {} }),
  methods: {
    ...mapActions({
      requestPageSettings: 'studentSurvey/requestPageSettings'
    }),
    getAnswer(item = {}, questionId = '') {
      const answers = get(item, 'answers', [])
      if (Array.isArray(answers) && answers.length) {
        const answer = answers.find(a => a.question === questionId)
        const question = this.questionHeaders.find(q => q.value === questionId)
        const questionType = get(question, 'type', '')
        if (questionType === 'text') return get(answer, 'answer', '--')
        if (questionType === 'multiple')
          return get(answer, 'answers', [])
            .map(a => `- ${a.title}`)
            .join('<br/>')
        return get(answer, 'answer.title', '--')
      }
      return '--'
    },
    onEdit(item) {
      this.$refs['edit-popup'].openPopup(item)
    }
  },
  computed: {
    ...mapState('studentSurvey', ['count', 'items', 'pageText', 'loading']),
    ...mapState({
      questions: state => state.surveyQuestion.items
    }),
    footerTable() {
      const footer = {
        'items-per-page-text': 'Số đăng ký mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 5,
        'page-text': this.pageText
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    },
    questionHeaders() {
      return this.questions.map((q, i) => ({ text: `Câu hỏi ${i + 1}: ${q.title}`, value: q.id, type: q.type }))
    },
    headers() {
      const headers = [
        { text: 'Học sinh', value: 'student' },
        { text: 'Trả lời lúc', value: 'createdAt', align: 'center' },
        { text: 'Thao tác', value: 'actions', align: 'center' }
      ]
      headers.splice(1, 0, ...this.questionHeaders)
      return headers
    }
  },
  watch: {
    tableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage
          })
        }
      },
      deep: true
    }
  }
}
</script>
